import axios from "axios";
import {
  CANCEL_SUBSCRIPTION_ENDPOINT,
  SUBSCRIBED_PLAN_ENDPOINT,
  SUBSCRIPTION_PAYMENT_HISTORY_ENDPOINT,
} from "./endpoints";
import { handleHTTPError } from "./errorHandlerActions";
import { GET_SUBSCRIPTION } from "./types";
import Format from "string-format";
import { BILLING_AND_PRICING_DATE_FORMAT } from "../_components/details/constants";
import { analyticsTrackEvent } from "../_utils/common";
import { syncWorkspaces } from "./authActions";
import dayjs from "dayjs";
import { showToast } from "../_utils/showToast";
import { t } from "i18next";

export const getSubscription = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    axios
      .get(SUBSCRIBED_PLAN_ENDPOINT)
      .then((res) => {
        if (res.data?.subscription?.trial_remaining_days < 0) {
          dispatch(syncWorkspaces());
          analyticsTrackEvent("freeTrialEnded");
        }

        const today = new Date();
        if (
          res.data?.subscription?.plan?.amount > 0 &&
          dayjs(today).format(BILLING_AND_PRICING_DATE_FORMAT) >
            dayjs(res.data?.subscription?.current_period_end).format(
              BILLING_AND_PRICING_DATE_FORMAT
            )
        ) {
          analyticsTrackEvent("subscriptionEnded", {
            subscriptionId: res.data?.subscription?.plan?.id,
          });
        }

        dispatch({
          type: GET_SUBSCRIPTION,
          payload:
            res.status === 400
              ? { subscription: {}, features: [], addons: [] }
              : res.data,
        });

        resolve(res.data);
      })
      .catch((error) => {
        handleHTTPError(error);
      });
  });
};

export const cancelSubscription =
  (subscriptionId, subscriptionLastDate) => (dispatch) => {
    const lastDate = dayjs(subscriptionLastDate).format(
      BILLING_AND_PRICING_DATE_FORMAT
    );

    return axios
      .put(Format(CANCEL_SUBSCRIPTION_ENDPOINT, subscriptionId))
      .then((res) => {
        analyticsTrackEvent("subscriptionCancelled", {
          subscriptionId: subscriptionId,
        });
        showToast({
          description: t("subscription.validity_msg", {
            last_date: lastDate,
            ns: "workspace",
          }),
          title: t("subscription.subs_cancel", { ns: "workspace" }),
          status: "success",
        });
      })
      .catch((error) => {
        handleHTTPError(error);
        showToast({
          description: t("errors.something_went_wrong", { ns: "common" }),
          title: t("error", { ns: "common" }),
          status: "error",
        });
      });
  };

export const fetchPaymentHistory = () => (dispatch) => {
  return axios
    .get(SUBSCRIPTION_PAYMENT_HISTORY_ENDPOINT)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      handleHTTPError(error);
      return error;
    });
};
